export const useStackedColorsAndSizes = (
  productCategory?: string
): {
  useLargeWidthSizeSelectorItems: boolean
} => {
  return {
    useLargeWidthSizeSelectorItems: productCategory === 'Shoes',
  }
}
